import { KitAssemblyDetail } from "./kit-assembly-detail";
import { SystemField } from "./system-field";

export class KitAssembly extends SystemField{ 
     ref_code?:string;
     external_ref_code?:string;
     assembly_date?:string;
     status?:string;
     post_period?:string;
     reason_code_id?:string;
     total_qty?:number;
     total_cost?:number;
     product_id?:string;
     assembly_type?:string;
     post_date?:string;
     warehouse_id?:string;
     kit_spec_id?:string;
     revision?:string;
     trans_uom_id?:string;
     base_uom_id?:string;
     location_id?:string;
     qty?:number;

     // relationship
     details?:KitAssemblyDetail[];

}
